import styled from 'styled-components';
import Button from '../../Button';
import { FlexColumn } from '../../Flex';
import { Suggestion } from '../types';
import { fontSize, fontWeight, radius, space } from '../../../style/utils';

const Wrapper = styled(FlexColumn)<{ $maxWidth?: number }>`
  width: 100%;
  align-self: center;
  gap: ${space('sm')};
  align-items: center;
  padding: ${space('xxl', 'xxl', 'lg')};
  max-width: ${({ $maxWidth }) => ($maxWidth ? `${$maxWidth}px` : 'none')};
`;

const SuggestionButton = styled(Button)`
  max-width: 100%;
  min-width: 0;
  border-radius: ${radius('pill')};
  font-size: ${fontSize('md')};
  font-weight: ${fontWeight('regular')};
  line-height: normal;
  color: ${({ theme }) => theme.palette.content.secondary};
`;

const ButtonText = styled.span`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const NewTag = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: ${space('hairline', 'smMinus')};
  border-radius: ${radius('pill')};
  font-size: ${fontSize('xxs')};
  font-weight: ${fontWeight('semibold')};
  letter-spacing: 0.4px;
  background: ${({ theme }) => theme.palette.accent.aiSubtle};
  color: ${({ theme }) => theme.palette.accent.ai};
  margin-left: ${space('sm')};
  flex-shrink: 0;
`;

type Props = {
  suggestions: Suggestion[];
  onClick: (value: string) => void;
  maxWidth?: number;
  disabled?: boolean;
};

const normalize = (item: Suggestion): { label: string; isNew: boolean } =>
  typeof item === 'string'
    ? { label: item, isNew: false }
    : { label: item.label, isNew: !!item.isNew };

const SuggestionSection = ({
  suggestions,
  onClick,
  maxWidth,
  disabled,
}: Props) => {
  if (!suggestions.length) return null;

  return (
    <Wrapper $maxWidth={maxWidth}>
      {suggestions.map((item) => {
        const { label, isNew } = normalize(item);
        return (
          <SuggestionButton
            key={label}
            variant="outlined"
            disabled={disabled}
            onClick={() => onClick(label)}
          >
            <ButtonText>{label}</ButtonText>
            {isNew && <NewTag>NEW</NewTag>}
          </SuggestionButton>
        );
      })}
    </Wrapper>
  );
};

export default SuggestionSection;
